import styled from 'styled-components';
export const Badge = styled.div `
  width: fit-content;
  height: 16px;
  color: ${({ theme }) => theme.colorsV2.font.textWhite};
  border-radius: 12px;
  font-size: ${({ theme }) => theme.fontSizesV2.label10.lg};
  line-height: 8px;
  font-weight: 600;
  text-transform: uppercase;
`;
//# sourceMappingURL=Badge.styled.js.map